import React from "react";
import { func, string, number } from "prop-types";
import Button from "pages/_components/Button";
import ReactTagWithoutInput from "./ReactTagWithoutInput";

const FilterTags = ({ openSideBarFilters, optionThirdParty, positionTab }) => (
    <div className="tags-filter">
        <Button
            image="images/figma/icon/filter.svg"
            onClick={openSideBarFilters}
            label="global.filter"
            className="btn btn-link open-filters"
            block={false}
        />
        <ReactTagWithoutInput optionThirdParty={optionThirdParty} positionTab={positionTab} />
    </div>
);

FilterTags.propTypes = {
    openSideBarFilters: func.isRequired,
    optionThirdParty: string.isRequired,
    positionTab: number.isRequired,
};

export default FilterTags;
